import window from "core/includes/window";

/**
 * @param {string} host
 * @return {string}
 * @example getSubdomain() // 'www'
 * @example getSubdomain() // 'toolbox-uat'
 * @example getSubdomain('a.b.c.site.com') // 'a.b.c'
 */
export function getSubdomain(host = window.location?.host || "") {
    return host.split('.').slice(0, -2).join('.');
}

/**
 * @param {!string} searchString
 * @returns {string}
 * @example searchParamsWithoutEmptyStringValues('a=&b='); // 'a&b'
 */
export function searchParamsWithoutEmptyStringValues(searchString: string) {
    return searchString.replace(/=(?=&|$)/, '');
}
